import { LOCALE_GROUPS, POPULATION_WEIGHT_UNITS } from '../constants/units';
import {
  REQUEST_PLANTING_METADATA,
  RECEIVE_PLANTING_METADATA,
  FAILURE_PLANTING_METADATA,
  RECEIVE_PLANTING_ANALYTICS,
} from '../constants/actionTypes';
import { EVENT_TYPES } from '../constants/eventTypes';

export const initialState = {
  isFetching: false,
  hasFetched: false,
  didError: false,
};

/**
 * Handles redux state for planting
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */

function plantingReducer(state = initialState, action = {}) {
  // NOSONAR
  switch (action.type) {
    case REQUEST_PLANTING_METADATA: {
      const prevState = action.clearState ? {} : state;
      return {
        ...prevState,
        isFetching: true,
        hasFetched: false,
        didError: false,
      };
    }
    case RECEIVE_PLANTING_METADATA: {
      const updatedFlags = {
        ...state,
        isFetching: false,
        hasFetched: true,
        didError: false,
      };

      if (!action.metadata) {
        return {
          ...updatedFlags,
          [action.season]: {},
        };
      }

      let areaVal;
      let areaUnit;
      const hybrids = [];
      let populationVal;
      let populationUnit;
      let date;
      let eventType;

      const actual = Array.isArray(action.metadata.actual)
        ? action.metadata.actual
        : [];
      const recorded = Array.isArray(action.metadata.recorded)
        ? action.metadata.recorded
        : [];
      const plantings = [...actual, ...recorded].filter(
        (planting) => planting.season === action.season
      );

      if (actual.length) {
        eventType = EVENT_TYPES.ACTUAL;
      } else if (recorded.length) {
        eventType = EVENT_TYPES.RECORDED;
      }

      if (plantings.length) {
        plantings.forEach((event) => {
          // NOSONAR
          const {
            area,
            population,
            'seed-product': seedProduct,
            'planting-start-time': plantingDate,
          } = event;
          if (area) {
            areaVal = area.q + (!areaVal ? 0 : areaVal);
            if (!areaUnit) {
              areaUnit = area.u;
            }
          }
          const name = seedProduct && seedProduct.name;
          if (name && !hybrids.includes(name)) {
            hybrids.push(name);
          }
          if (population && area) {
            populationVal =
              population.q * area.q + (!populationVal ? 0 : populationVal);
            if (!populationUnit) {
              populationUnit = population.u;
            }
          }
          if (!date || plantingDate > date) {
            date = plantingDate;
          }
        });
      }
      const population =
        populationVal && areaVal
          ? { q: populationVal / areaVal, u: populationUnit }
          : populationVal;
      const area = areaVal ? { q: areaVal, u: areaUnit } : areaVal;

      const populationWithLocaleGroup = population && {
        ...population,
        localeGroup:
          population.u === POPULATION_WEIGHT_UNITS.PLANTING
            ? LOCALE_GROUPS.POPULATION_WEIGHT
            : LOCALE_GROUPS.POPULATION,
      };

      return {
        ...updatedFlags,
        [action.season]: {
          area,
          date: date ? date.substring(0, date.indexOf('T')) : date,
          hybrids,
          population: populationWithLocaleGroup,
          eventType,
        },
      };
    }

    case FAILURE_PLANTING_METADATA:
      return {
        ...state,
        isFetching: false,
        hasFetched: true,
        didError: true,
        [action.season]: {},
      };
    case RECEIVE_PLANTING_ANALYTICS: {
      const { events } = action;
      return {
        isFetching: false,
        hasFetched: true,
        didError: false,
        ...events
      }
    }
    default:
      return state;
  }
}

export default plantingReducer;
